export default __webpack_public_path__ + "media/icons/illo-clock-homepage-57611d12.svg";